// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vw_a bhh_b bhh_wb"};